import { useScrollReveal } from "../lib/useScrollReveal";

export const FinalCTA = ({ onBook }) => {
  const ref = useScrollReveal();
  return (
    <section
      id="final-cta"
      data-testid="final-cta"
      ref={ref}
      className="relative overflow-hidden bg-[#1F4A38] text-[#F9F6F0]"
    >
      <div className="grain absolute inset-0" />
      <div className="relative max-w-4xl mx-auto px-6 md:px-10 py-24 md:py-36 text-center">
        <p className="reveal text-[11px] tracking-[0.35em] uppercase text-[#D4A24C] mb-6 font-medium">
          Begin Today
        </p>
        <h2
          data-testid="final-cta-heading"
          className="reveal font-serif-display text-5xl sm:text-6xl md:text-7xl leading-[1.05] font-light"
        >
          Ready to Begin <em className="italic text-[#EAC98A]">Your</em> Journey?
        </h2>
        <p className="reveal mt-8 max-w-xl mx-auto text-[#F9F6F0]/85 font-light text-base md:text-lg">
          Take the first step towards a healthier, more balanced you. A single breath
          changes everything.
        </p>
        <button
          data-testid="final-cta-btn"
          onClick={onBook}
          className="reveal mt-10 inline-flex items-center gap-2 bg-[#D4A24C] hover:bg-[#C29344] text-[#153326] rounded-full px-10 py-4 text-sm font-semibold tracking-wide shadow-[0_18px_50px_rgba(212,162,76,0.35)] hover:shadow-[0_24px_60px_rgba(212,162,76,0.55)] transition-all duration-400 hover:-translate-y-0.5"
        >
          Book a Free Trial Class
          <span>→</span>
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
